module.exports = __webpack_public_path__ + "static/media/pr_details2.c79e6693.jpg";